import React from 'react';
import { ArrowRight, Shield } from 'lucide-react';

const CTASection = ({ onOpenForm }) => {
  return (
    <section id="cta" className="py-20 bg-gradient-to-br from-primary via-gray-900 to-primary text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://images.unsplash.com/photo-1758599543129-5269a8f29e68"
          alt="Professional handshake background"
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="bg-secondary w-20 h-20 rounded-full flex items-center justify-center shadow-xl">
              <Shield size={40} className="text-white" />
            </div>
          </div>

          {/* Heading */}
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight text-white">
            Don't Wait – Protect Your Brand <span className="text-secondary">Today</span>
          </h2>
          
          {/* Subheading */}
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            Every day without trademark protection is a day your brand is vulnerable. Secure your business name, logo, and brand identity with expert USPTO filing services. Join thousands of businesses who trust us to protect their most valuable asset.
          </p>

          {/* Urgency Message */}
          <div className="bg-secondary/20 backdrop-blur-sm border border-secondary/30 rounded-lg p-6 mb-8 inline-block">
            <div className="flex items-center justify-center space-x-3">
              <ArrowRight className="text-secondary" size={24} />
              <span className="font-semibold text-lg">Limited Time Offer: Free Comprehensive Trademark Search ($200 Value)</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button
              onClick={onOpenForm}
              className="bg-secondary text-white px-10 py-5 rounded-md hover:bg-secondary/90 transition-all font-bold shadow-2xl hover:shadow-3xl text-lg flex items-center justify-center space-x-2"
            >
              <span>Register My Trademark Now</span>
              <ArrowRight size={20} />
            </button>
            <button
              onClick={() => document.getElementById('pricing').scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-primary px-10 py-5 rounded-md hover:bg-accent transition-all font-bold shadow-2xl text-lg"
            >
              View Pricing Plans
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-3 gap-6 max-w-2xl mx-auto pt-8 border-t border-white/20">
            <div>
              <div className="text-3xl font-bold text-secondary mb-1">1000+</div>
              <div className="text-sm text-gray-300">Trademarks Filed</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-secondary mb-1">95%</div>
              <div className="text-sm text-gray-300">Success Rate</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-secondary mb-1">15+</div>
              <div className="text-sm text-gray-300">Years Experience</div>
            </div>
          </div>

          {/* Additional Message */}
          <p className="text-sm text-gray-400 mt-8">
            ✓ No Hidden Fees &nbsp;&nbsp; ✓ Expert Support &nbsp;&nbsp; ✓ 100% Satisfaction Guarantee
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
